import { render, staticRenderFns } from "./InfoAttr.vue?vue&type=template&id=8524cb18&scoped=true"
import script from "./InfoAttr.vue?vue&type=script&lang=js"
export * from "./InfoAttr.vue?vue&type=script&lang=js"
import style0 from "./InfoAttr.vue?vue&type=style&index=0&id=8524cb18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8524cb18",
  null
  
)

export default component.exports